import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { STYLES } from "./ShoppingCartStyles";
import { X } from "@phosphor-icons/react";

interface DrawerHeaderProps {
  onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({ onClose }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 4
    }}
  >
    <Typography
      variant="h6"
      sx={{
        fontFamily: STYLES.fontFamily,
        fontWeight: "bold",
        fontSize: "22px",
      }}
    >
      Carrito de Compras
    </Typography>
    <IconButton onClick={onClose}>
      <X size={24} />
    </IconButton>
  </Box>
);














